<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-expand-lg bg-white">
					<!-- Page title -->
					<div class="navbar-text nav-title flex" id="pageTitle">Public Task Bank Comments</div>

					<!-- Search field -->
					<div>
						<!-- <form class="input-group m-2 my-lg-0">
							<span class="input-group-btn">
								<button type="button" class="btn no-border no-bg no-shadow">
									<i class="fa fa-search"></i>
								</button>
							</span>
							<input type="text" v-model="filter" class="form-control" placeholder="Search students..." />
						</form> -->
					</div>
				</div>

				<div class="content-main">
					<div class>
						<!-- Page content goes here -->
						<b-table
							ref="table"
							responsive="lg"
							striped
							hover
							:show-empty="true"
							:items="table_provider"
							:fields="table_fields"
							:current-page="currentPage"
							:per-page="perPage"
							:filter="filter"
							:sort-by.sync="sortBy"
							:sort-desc.sync="sortDesc"
						>
							<template slot="created_at" slot-scope="data">
								{{ fs.medDate(data.item.created_at) }}
							</template>

							<template slot="user" slot-scope="data">
								<template v-if="data.item.user && data.item.user.name">
									{{ data.item.user.name }}
								</template>
								<template v-else>
									<div class="text-muted">(Unknown)</div>
								</template>
							</template>

							<template slot="assessment" slot-scope="data">
								<template v-if="data.item.assessment && data.item.assessment.name">
									{{ data.item.assessment.name }}
								</template>
								<template v-else>
									<div class="text-muted">(Unknown)</div>
								</template>
							</template>

							<template slot="comment" slot-scope="data">
								<div class="comment-box">
									{{ data.item.text }}
								</div>
							</template>

							<template slot="status" slot-scope="data">
								<div v-if="data.item.status == 0" class="text-warning">Pending</div>
								<div v-if="data.item.status == 1" class="text-success">Visible</div>
								<div v-if="data.item.status == -1" class="text-danger">Rejected</div>
								<div v-if="data.item.updated_user" class="text-muted text-xxs">
									{{ data.item.updated_user.scorer_id }}
								</div>
							</template>

							<template slot="actions" slot-scope="data">
								<nobr>
									<div class="mx-auto w90">
										<button
											@click="rejectComment(data.item)"
											class="btn btn-sm btn-icon btn-rounded red text-white m-0"
											v-tippy
											title="Delete"
										>
											<i class="far fa-trash"></i>
										</button>
										<button
											v-if="data.item.status != 1"
											@click="accept(data.item.id)"
											class="btn btn-sm btn-icon btn-rounded green text-white m-0"
											v-tippy
											title="Accept"
										>
											<i class="far fa-check"></i>
										</button>
										<button
											v-else
											class="btn btn-sm btn-icon btn-rounded btn-secondary text-white m-0"
											v-tippy
											title="Accept"
											disabled
										>
											<i class="far fa-check"></i>
										</button>
									</div>
								</nobr>
							</template>
						</b-table>
					</div>
				</div>

				<div class="p-1 b-t mt-auto white d-flex flex-row align-items-center">
					<a class="flex mx-3"
						>Page {{ totalRows > 0 ? currentPage : 0 }} of {{ Math.ceil(totalRows / perPage) }} ({{
							totalRows
						}})</a
					>
					<div>
						<b-pagination
							size="md"
							class="m-1"
							:total-rows="totalRows"
							v-model="currentPage"
							:per-page="perPage"
						></b-pagination>
					</div>
				</div>
			</div>
		</div>

		<b-modal id="deleteConfirm" :visible="deleting != false" @hide="deleting = false">
			<template slot="modal-title">Delete Comment</template>
			<div class="row px-4 pb-3">
				<div>Are you sure you want to delete this comment?</div>
				<div v-if="deleting" class="comment-box mt-3">{{ deleting.text }}</div>
			</div>
			<template slot="modal-footer">
				<button class="btn primary btn-flat" @click="deleting = false">Cancel</button>
				<button class="btn danger btn-flat" @click="deleteComment(deleting)">Delete</button>
			</template>
		</b-modal>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w60 {
	width: 60px;
}
.comment-box {
	background-color: rgba(0, 0, 0, 0.05);
	border-radius: 0.5rem;
	border: 1px solid rgba(0, 0, 0, 0.1);
	padding: 0.25rem 0.5rem;
}
</style>

<script>
import TaskBankService from "@/services/TaskBankService";
import fs from "@/services/FormatService";
import notie from "@/services/NotieService";
import store from "@/services/Store";

export default {
	name: "CommentList",

	props: ["user"],

	data() {
		return {
			fs: fs,

			table_fields: [
				{
					key: "created_at",
					label: "Time",
					tdClass: "v-mid",
					sortable: true,
				},
				{
					key: "assessment",
					label: "Assessment",
					tdClass: "v-mid",
				},
				{
					key: "user",
					label: "Commenter",
					tdClass: "v-mid",
				},
				{
					key: "comment",
					label: "Comment",
					tdClass: "v-mid",
				},
				{
					key: "status",
					label: "Status",
					tdClass: "_600 v-mid",
				},
				{
					key: "actions",
					label: "Actions",
					tdClass: "v-mid",
				},
			],
			currentPage: 1,
			perPage: 10,
			totalRows: 0,
			filter: "",
			sortBy: null,
			sortDesc: false,
			loading: true,

			deleting: false,
		};
	},

	components: {},

	created() {
		this.sortBy = store.get(this, "comments.sortBy");
		this.sortDesc = store.getDefault(this, "comments.sortDesc", false);
	},

	watch: {
		sortBy() {
			store.set(this, "comments.sortBy", this.sortBy);
		},
		sortDesc() {
			store.set(this, "comments.sortDesc", this.sortDesc);
		},
	},

	methods: {
		table_provider(ctx) {
			return TaskBankService.listAllComments(ctx)
				.then((resp) => {
					this.totalRows = resp.data.totalRows;
					return resp.data.comments;
				})
				.catch((err) => {
					console.log(err);
					notie.error("Failed to load comments", err);
					return [];
				})
				.finally(() => {
					this.loading = false;
				});
		},

		accept(id) {
			return TaskBankService.setCommentStatus(id, 1)
				.then((r) => {
					notie.success("Comment Accepted", "This comment will now be visible on the public task bank page.");
					this.refreshTable();
				})
				.catch((e) => {
					console.error(e);
					notie.error("Failed to update comment", e);
				});
		},

		rejectComment(comment) {
			this.deleting = comment;
		},

		deleteComment(comment) {
			return TaskBankService.setCommentStatus(comment.id, -1)
				.then((r) => {
					this.deleting = false;
					notie.error("Comment deleted");
					this.refreshTable();
				})
				.catch((e) => {
					this.deleting = false;
					console.error(e);
					notie.error("Failed to update comment", e);
				});
		},

		refreshTable() {
			this.$refs.table.refresh();
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/CommentList.vue